import { graphql } from '@/generated/gql';

export const SAVE_QUERY_MUTATION = graphql(/* GraphQL */ `
  mutation SaveQuery($query: jsonb, $checksum: String) {
    insert_queries_one(
      object: { query: $query, checksum: $checksum }
      on_conflict: { constraint: queries_checksum_key, update_columns: [checksum] }
    ) {
      id
    }
  }
`);
